import React from 'react';
import { DialogContent } from '@mui/material';


export const HDialogContent = ({ children, ...restProps }) => (
  <DialogContent dividers {...restProps}>
    {children}
  </DialogContent>
);
